import Icon from "components/Common/Icon";
import { getWowStatic } from "hooks/wow/getStaticData";
import React from "react";
import WowTooltip from "../Tooltips/WowTooltip";

const Gem = ({ id }) => {
  const staticData = getWowStatic("item", id);

  return staticData ? (
    <WowTooltip type="item" id={id}>
      <Icon staticDataImg={staticData.img} iconSize="16px" />
    </WowTooltip>
  ) : null;
};

// gems arrives as the builds payload string: "" or "-"-joined gem item ids.
const GemIcons = ({ gems }) => {
  const gemIds = gems
    ? String(gems)
        .split("-")
        .filter((id) => parseInt(id) > 0)
    : [];

  if (gemIds.length === 0) return null;

  return (
    <div className="gems-container">
      {gemIds.map((id, index) => (
        <Gem key={index} id={id} />
      ))}
    </div>
  );
};

export default GemIcons;
